import {
  loginFailure,
  loginRequest,
  loginSuccess,
  mfaInitFailure,
  mfaVerifyFailure,
  mfaVerifyRequest,
  mfaVerifySuccess,
  signupFailure,
  signupRequest,
  signupSuccess,
} from 'store/reducers/authentication';
import {
  signupDataValidateFailure,
  signupDataValidateSuccess,
} from 'store/reducers/signupForm';

import { fetchData } from './fetchData';
import { loadBootstrap } from './main';

export const logIn = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'user/login',
    actions: [loginRequest, loginSuccess, loginFailure],
    httpMethod: 'post',
    body,
    showAPIerror: true,
  })(dispatch, getState).then(({ success, data }) => {
    if (success) {
      const { token } = data.data;
      localStorage.setItem('token', token);
      dispatch(loadBootstrap());
    }
  });

export const signUp = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'user',
    actions: [signupRequest, signupSuccess, signupFailure],
    httpMethod: 'post',
    body: {
      ...body,
      isProvider: true,
    },
  })(dispatch, getState);

export const signupDataValidate = (body) => (dispatch, getState) => {
  const data = { ...body };
  delete data.isMarketable;
  return fetchData({
    endpoint: 'user/data/validate',
    actions: [null, signupDataValidateSuccess, signupDataValidateFailure],
    httpMethod: 'post',
    body: data,
    showAPIerror: true,
  })(dispatch, getState);
};

export const adminSignUp = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'user/bypass',
    actions: [signupRequest, signupSuccess, signupFailure],
    httpMethod: 'post',
    headers: {
      'x-pawcare-registration': '8413',
    },
    body: {
      ...body,
      isProvider: true,
    },
  })(dispatch, getState);

export const mfaInit = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'mfa/init',
    actions: [null, null, mfaInitFailure],
    httpMethod: 'post',
    body,
  })(dispatch, getState);

export const mfaVerify = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'mfa/verify',
    actions: [mfaVerifyRequest, mfaVerifySuccess, mfaVerifyFailure],
    httpMethod: 'post',
    body,
  })(dispatch, getState);

export const triggerPasswordChangeEmail = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'password/forgot',
    actions: [null, null, null],
    httpMethod: 'post',
    body,
  })(dispatch, getState);

export const resetPassword = (body) => (dispatch, getState) =>
  fetchData({
    endpoint: 'password/reset',
    actions: [null, null, null],
    httpMethod: 'patch',
    body,
  })(dispatch, getState);

export function logOut(redirectPath) {
  localStorage.clear();
  if (redirectPath && typeof redirectPath === 'string') {
    window.location.assign(redirectPath);
  }
}

// For testing purposes

export const deleteUser = () => (dispatch, getState) =>
  fetchData({
    endpoint: 'user',
    actions: [null, null, null],
    httpMethod: 'delete',
  })(dispatch, getState);
